import * as React from 'react';
import { Tooltip } from '@mui/material';

export type TooltipDataCellProps = {
  data: string;
  tooltip: string;
};

export const TooltipDataCell: React.FunctionComponent<
  TooltipDataCellProps
> = props => {
  const { data, tooltip } = props;
  return (
    <Tooltip title={tooltip}>
      <span>{data}</span>
    </Tooltip>
  );
};
